import { BooleanParam, NumberParam, QueryParamConfig, StringParam, withDefault } from 'use-query-params';
import { MonitoringReviewStatusEnum, PatientStudyStateEnum } from 'src/services/api/api-client';
import { PatientFilterParamsType } from 'src/components/patientTable/patientTable';
import { TagFiltersParam } from 'src/features/patientTags/TagFiltersParam';

const MonitoringReviewStatusParam = NumberParam as QueryParamConfig<
  MonitoringReviewStatusEnum | null | undefined,
  MonitoringReviewStatusEnum | null | undefined
>;

export const patientFilterParams = (
  defaultGroup?: number | null,
  defaultStudyState?: PatientStudyStateEnum | null,
): PatientFilterParamsType => ({
  patientGroup: withDefault(NumberParam, defaultGroup),
  isClinic: BooleanParam,
  isControlled: BooleanParam,
  canBeArchived: BooleanParam,
  needChecking: BooleanParam,
  hasNoApp: BooleanParam,
  studyState: withDefault(NumberParam, defaultStudyState),
  searchQuery: StringParam,
  studyStartNotDefine: BooleanParam,
  tags: TagFiltersParam,
  issueId: NumberParam,
  withActiveStepName: StringParam,
  withClosedStepName: StringParam,
  monitoringReviewStatus: MonitoringReviewStatusParam,
});

export function patientFilterToBackendRequest(query: {
  patientGroup?: number | null;
  isClinic?: boolean | null;
  isControlled?: boolean | null;
  canBeArchived?: boolean | null;
  hasNoApp?: boolean | null;
  needChecking?: boolean | null;
  studyState?: PatientStudyStateEnum | null;
  studyStartNotDefine?: boolean | null;
  tags?: Record<string, string[]>;
  withActiveStepName?: string | null;
  withClosedStepName?: string | null;
  monitoringReviewStatus?: MonitoringReviewStatusEnum | null;
}): {
  patientGroup: number;
  isClinic?: boolean | null;
  monitoringReviewStatus?: MonitoringReviewStatusEnum | null;
  isControlled?: boolean | null;
  canBeArchived?: boolean | null;
  hasNoApp?: boolean | null;
  needChecking?: boolean | null;
  studyState?: PatientStudyStateEnum | null;
  studyStartNotDefine?: boolean | null;
  tags?: Record<string, string[]>;
  withActiveStepName?: string | null;
  withClosedStepName?: string | null;
} {
  return {
    patientGroup: query.patientGroup ?? 0,
    isClinic: query.isClinic ?? undefined,
    isControlled: query.isControlled ?? undefined,
    canBeArchived: query.canBeArchived ?? undefined,
    hasNoApp: query.hasNoApp ?? undefined,
    needChecking: query.needChecking ?? undefined,
    studyState: query.studyState ?? undefined,
    studyStartNotDefine: query.studyStartNotDefine,
    tags: query.tags,
    withActiveStepName: query.withActiveStepName,
    withClosedStepName: query.withClosedStepName,
    monitoringReviewStatus: query.monitoringReviewStatus ?? undefined,
  };
}
